namespace GeniuzPOS.Product {
    export class CsArticleSeasonColumns {
        static columnsKey = 'Product.CsArticleSeason';
    }
}
